const initState = {
  showAlert: false,
  message: null,
};

export const alertReducer = (state = initState, action) => {
  switch (action.type) {
    case "SHOW_ALERT":
      return {
        ...state,
        showAlert: true,
        message: action.message,
      };
    case "CLOSE_ALERT":
      return {
        ...state,
        showAlert: false,
        message: null,
      };
    default:
      return state;
  }
};
